// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AddBlogDetails-space1-nhU2X {
	margin-bottom: 6px !important;
}

.AddBlogDetails-space2-b3WAY {
	margin-bottom: 12px !important;
}

.AddBlogDetails-space3-ixLwj {
	margin-bottom: 18px !important;
}

.AddBlogDetails-space4-iC5Oz {
	margin-bottom: 24px !important;
}

.AddBlogDetails-space5-rUbjT {
	margin-bottom: 30px !important;
}

.AddBlogDetails-space6-QgDX_ {
	margin-bottom: 36px !important;
}

.AddBlogDetails-space7-wYTMJ {
	margin-bottom: 42px !important;
}

.AddBlogDetails-space8-Qa9Bw {
	margin-bottom: 48px !important;
}

.AddBlogDetails-spaceTop1-thvt5 {
	margin-top: 6px !important;
}

.AddBlogDetails-spaceTop2-zvXqU {
	margin-top: 12px !important;
}

.AddBlogDetails-spaceTop3-yqq8V {
	margin-top: 18px !important;
}

.AddBlogDetails-spaceTop4-J8AzO {
	margin-top: 24px !important;
}

.AddBlogDetails-spaceTop5-hIcx3 {
	margin-top: 30px !important;
}

.AddBlogDetails-spaceTop6-YcXLr {
	margin-top: 36px !important;
}

.AddBlogDetails-spaceTop7-WZzB7 {
	margin-top: 42px !important;
}

.AddBlogDetails-spaceTop8-W8C1U {
	margin-top: 48px !important;
}

.AddBlogDetails-noMargin-LTWEv {
	margin: 0px !important;
}

.AddBlogDetails-padding1-aryVF {
	padding-bottom: 6px !important;
}

.AddBlogDetails-padding2-BhDLr {
	padding-bottom: 12px !important;
}

.AddBlogDetails-padding3-x162N {
	padding-bottom: 18px !important;
}

.AddBlogDetails-padding4-Ietab {
	padding-bottom: 24px !important;
}

.AddBlogDetails-padding5-dXPy2 {
	padding-bottom: 30px !important;
}

.AddBlogDetails-padding6-PXG3n {
	padding-bottom: 36px !important;
}

.AddBlogDetails-padding7-oZ_AQ {
	padding-bottom: 42px !important;
}

.AddBlogDetails-paddingTop1-GGqD0 {
	padding-top: 6px !important;
}

.AddBlogDetails-paddingTop2-wNAsj {
	padding-top: 12px !important;
}

.AddBlogDetails-paddingTop3-e0Tdg {
	padding-top: 18px !important;
}

.AddBlogDetails-paddingTop4-l8Ypj {
	padding-top: 24px !important;
}

.AddBlogDetails-paddingTop5-zHc3b {
	padding-top: 30px !important;
}

.AddBlogDetails-paddingTop6-rpaab {
	padding-top: 36px !important;
}

.AddBlogDetails-paddingTop7-sVNVU {
	padding-top: 42px !important;
}

.AddBlogDetails-noPadding-Kt0rQ {
	padding: 0px !important;
}

.AddBlogDetails-spaceMarginBottom0-mjpBs {
	margin-bottom: 0;
}

.AddBlogDetails-textBold-wdXr3 {
	font-weight: 500 !important;
}

.AddBlogDetails-textBolder-dzM5V {
	font-weight: 700 !important;
}

.AddBlogDetails-textNormal-Ek6jR {
	font-weight: normal !important;
}

/*New Design Text Colors */

.AddBlogDetails-textDarkBlue-rpbpO {
	color: rgb(20, 39, 94) !important;
}

.AddBlogDetails-textLightBlue-gFNXs {
	color: rgb(57, 87, 106) !important;
}

.AddBlogDetails-textLightSandleGreen-Y3dFo {
	color: rgb(76, 86, 41) !important;
}

.AddBlogDetails-textLightBrown-ufotR {
	color: rgb(115, 79, 33) !important;
}

.AddBlogDetails-textMediumMaroon-yuvx5 {
	color: rgb(87, 37, 51) !important;
}

.AddBlogDetails-textBrown-uDoCa {
	color: rgb(160, 47, 24) !important;
}

.AddBlogDetails-textMaroon-WLLCd {
	color: rgb(155, 49, 67) !important;
}

.AddBlogDetails-textDarkBrown-jnTuc {
	color: rgb(83, 18, 16) !important;
}

.AddBlogDetails-textMediumBrown-JHN1Y {
	color: rgb(142, 28, 10) !important;
}

.AddBlogDetails-textSkyBlue-f6ZXy {
	color: rgb(37, 117, 141) !important;
}

.AddBlogDetails-textGray-joDYL {
	color: rgb(77, 65, 51) !important;
}

.AddBlogDetails-errorMessage-I3yRX {
  margin-top: 5px;
  margin-bottom: 5px;
  display: block;
  color: var(--alert-color);
  font-size: 14px;
  font-weight: normal;
  /* margin-left: 5px; */
}

/** Admin - Common - Start **/

.AddBlogDetails-userText-LjcwT {
	padding-top: 3px;
	color: var(--common-text-color);
	margin: 0px;
	font-size: 14px;
}

.AddBlogDetails-panelHeader-tW9L7 {
	border-radius: 4px;
	padding: 20px 25px;
	border: 1px solid var(--primary-border);
}

.AddBlogDetails-exportSection-KTYlc {
	background: var(--common-gray-bg-color);
	padding: 24px 15px;
	display: grid;
	grid-template-columns: 28% 15% 55%;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	grid-gap: 11px;
	border: 1px solid var(--primary-border);
	border-bottom: 0;
	border-top-left-radius: 20px;
	border-top-right-radius: 20px;
}

.AddBlogDetails-exportSectionGridSub-S5v8f {
	grid-template-columns: 50% 49% !important;
}

.AddBlogDetails-exportText-Wprf1 {
	color: var(--common-text-color) !important;
	text-decoration: none !important;
	display: inline-block;
	float: right;
}

.AddBlogDetails-exportLinkImg-IM8gA {
	background: var(--primary-white-bg);
	padding: 10px;
	margin-left: 12px;
	border-radius: 4px;
}

.AddBlogDetails-exportImg-Aw4Xf {
	width: 100%;
	max-width: 16px;
	vertical-align: middle;
}

.AddBlogDetails-linkBtn-B__Ai {
	line-height: 24px;
	display: inline-block;
	vertical-align: middle;
	margin-right: 15px;
	text-align: center;
}

.AddBlogDetails-table-RD1ng {
	display: table;
}

.AddBlogDetails-tableRow-zKcow {
	display: table-row;
}

.AddBlogDetails-tableCell-jyvxv {
	display: table-cell;
	float: none;
}

.AddBlogDetails-formGroup-li5nf {
	margin-bottom: 6px;
}

.AddBlogDetails-marginTop0-J57jK {
	margin-top: 0;
}

.AddBlogDetails-marginBottom20-BMIaJ {
	margin-bottom: 20px;
}

/******************* Admin Banner Image Section Start ****************/

.AddBlogDetails-bannerImageBg-BrIap {
	width: 100%;
	height: 100%;
	min-height: 179px;
	background-size: contain;
	background-repeat: no-repeat;
	background-position: 50% 50%;
	position: relative;
	border-radius: 0px;
}

.AddBlogDetails-bannerDelete-NeQVR {
	position: absolute;
	top: 5px;
	right: 20px;
}

/*******************Admin Modal Start **********************/

a,
a:hover {
	cursor: pointer;
}

.AddBlogDetails-exportLink-Id88g {
	padding-top: 10px;
	padding-right: 10px;
}

.AddBlogDetails-seachContent-cgPNq {
	padding-left: 0px;
	margin-bottom: 5px;
}

.AddBlogDetails-marginBottom9-woYkn {
	margin-bottom: 9px;
}

.AddBlogDetails-spaceTop52-FyWvT {
	margin-top: 52px;
}

.AddBlogDetails-profileViewInner-ebEPV {
	padding: 10px;
	border-top: 1px solid var(--primary-border);
	word-break: break-all;
}

.AddBlogDetails-profileViewMain-dgcTf {
	border: 1px solid var(--primary-border);
	border-radius: 0px;
	border-top: 0;
}

.AddBlogDetails-profileViewlabel-Z5WQP {
	display: inline-block;
	width: 38%;
	vertical-align: middle;
}

.AddBlogDetails-profileViewMainContent-O6CvB {
	display: inline-block;
	width: 62%;
	vertical-align: middle;
}

.AddBlogDetails-reviewsFormStar-FTtYV {
	font-size: 32px;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	gap: 2px;
	-ms-flex-wrap: wrap;
	    flex-wrap: wrap;
}

.AddBlogDetails-reviewsFormStar-FTtYV svg {
	cursor: pointer;
}

.AddBlogDetails-addLanguageText-FqEpA {
	font-size: 16px;
}

/***************** Export Section Start *********************/

@media screen and (max-width: 991px) {
	.AddBlogDetails-exportSection-KTYlc {
		grid-template-columns: 100%;
	}

	.AddBlogDetails-spaceTop52-FyWvT {
		margin-top: 18px;
	}

	.AddBlogDetails-exportText-Wprf1 {
		float: none;
		margin-top: 12px;
	}

	.AddBlogDetails-exportSectionGridSub-S5v8f {
		grid-template-columns: 100% !important;
	}
}

/***************** Export Section End *********************/

/*******************Admin Modal Start **********************/

/*******************Admin Modal End **********************/

/*********************** Profile View Section  Start***********************/

@media screen and (max-width: 767px) {
	.AddBlogDetails-profileViewlabel-Z5WQP {
		width: 100%;
		margin-bottom: 6px;
		text-align: center;
	}

	.AddBlogDetails-profileViewMainContent-O6CvB {
		width: 100%;
		text-align: center;
	}

	.AddBlogDetails-panelHeader-tW9L7 {
		padding: 15px 15px;
	}

}

/*********************** Profile View Section  Start***********************/

.AddBlogDetails-addBlogCommonInputGrp-dBxnM {
    margin-bottom: 24px;
    padding-bottom: 24px;
    border-bottom: 1px solid var(--primary-border);
}`, "",{"version":3,"sources":["webpack://./src/components/helpers.css","webpack://./src/components/utils.css","webpack://./src/components/siteadmin/admin-common.css","webpack://./src/components/siteadmin/AddBlogDetails/AddBlogDetails.css"],"names":[],"mappings":"AAAA;CACC,6BAA6B;AAC9B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA,0BAA0B;;AAE1B;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,mCAAmC;AACpC;;AAEA;CACC,iCAAiC;AAClC;;AC5LA;EACE,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,mBAAmB;EACnB,sBAAsB;AACxB;;ACLA,6BAA6B;;AAC7B;CACC,gBAAgB;CAChB,+BAA+B;CAC/B,WAAW;CACX,eAAe;AAChB;;AAEA;CACC,kBAAkB;CAClB,kBAAkB;CAClB,uCAAuC;AACxC;;AAEA;CACC,uCAAuC;CACvC,kBAAkB;CAClB,aAAa;CACb,kCAAkC;CAClC,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,cAAc;CACd,uCAAuC;CACvC,gBAAgB;CAChB,4BAA4B;CAC5B,6BAA6B;AAC9B;;AAEA;CACC,yCAAyC;AAC1C;;AAEA;CACC,0CAA0C;CAC1C,gCAAgC;CAChC,qBAAqB;CACrB,YAAY;AACb;;AAEA;CACC,mCAAmC;CACnC,aAAa;CACb,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,WAAW;CACX,eAAe;CACf,sBAAsB;AACvB;;AAEA;CACC,iBAAiB;CACjB,qBAAqB;CACrB,sBAAsB;CACtB,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,mBAAmB;CACnB,WAAW;AACZ;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,mBAAmB;AACpB;;AAGA,sEAAsE;;AACtE;CACC,WAAW;CACX,YAAY;CACZ,iBAAiB;CACjB,wBAAwB;CACxB,4BAA4B;CAC5B,4BAA4B;CAC5B,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,QAAQ;CACR,WAAW;AACZ;;AAEA,4DAA4D;;AAC5D;;CAEC,eAAe;AAChB;;AAEA;CACC,iBAAiB;CACjB,mBAAmB;AACpB;;AAEA;CACC,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,aAAa;CACb,2CAA2C;CAC3C,qBAAqB;AACtB;;AAEA;CACC,uCAAuC;CACvC,kBAAkB;CAClB,aAAa;AACd;;AAEA;CACC,qBAAqB;CACrB,UAAU;CACV,sBAAsB;AACvB;;AAEA;CACC,qBAAqB;CACrB,UAAU;CACV,sBAAsB;AACvB;;AAEA;CACC,eAAe;CACf,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,QAAQ;CACR,mBAAe;KAAf,eAAe;AAChB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,eAAe;AAChB;;AAEA,6DAA6D;;AAC7D;CACC;EACC,2BAA2B;CAC5B;;CAEA;EACC,gBAAgB;CACjB;;CAEA;EACC,WAAW;EACX,gBAAgB;CACjB;;CAEA;EACC,sCAAsC;CACvC;AACD;;AAEA,2DAA2D;;AAC3D,4DAA4D;;AAE5D,0DAA0D;;AAE1D,2EAA2E;;AAG3E;CACC;EACC,WAAW;EACX,kBAAkB;EAClB,kBAAkB;CACnB;;CAEA;EACC,WAAW;EACX,kBAAkB;CACnB;;CAEA;EACC,kBAAkB;CACnB;;AAED;;AAEA,2EAA2E;;ACtN3E;IACI,mBAAmB;IACnB,oBAAoB;IACpB,8CAA8C;AAClD","sourcesContent":[".space1 {\n\tmargin-bottom: 6px !important;\n}\n\n.space2 {\n\tmargin-bottom: 12px !important;\n}\n\n.space3 {\n\tmargin-bottom: 18px !important;\n}\n\n.space4 {\n\tmargin-bottom: 24px !important;\n}\n\n.space5 {\n\tmargin-bottom: 30px !important;\n}\n\n.space6 {\n\tmargin-bottom: 36px !important;\n}\n\n.space7 {\n\tmargin-bottom: 42px !important;\n}\n\n.space8 {\n\tmargin-bottom: 48px !important;\n}\n\n.spaceTop1 {\n\tmargin-top: 6px !important;\n}\n\n.spaceTop2 {\n\tmargin-top: 12px !important;\n}\n\n.spaceTop3 {\n\tmargin-top: 18px !important;\n}\n\n.spaceTop4 {\n\tmargin-top: 24px !important;\n}\n\n.spaceTop5 {\n\tmargin-top: 30px !important;\n}\n\n.spaceTop6 {\n\tmargin-top: 36px !important;\n}\n\n.spaceTop7 {\n\tmargin-top: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-top: 48px !important;\n}\n\n.noMargin {\n\tmargin: 0px !important;\n}\n\n.padding1 {\n\tpadding-bottom: 6px !important;\n}\n\n.padding2 {\n\tpadding-bottom: 12px !important;\n}\n\n.padding3 {\n\tpadding-bottom: 18px !important;\n}\n\n.padding4 {\n\tpadding-bottom: 24px !important;\n}\n\n.padding5 {\n\tpadding-bottom: 30px !important;\n}\n\n.padding6 {\n\tpadding-bottom: 36px !important;\n}\n\n.padding7 {\n\tpadding-bottom: 42px !important;\n}\n\n.paddingTop1 {\n\tpadding-top: 6px !important;\n}\n\n.paddingTop2 {\n\tpadding-top: 12px !important;\n}\n\n.paddingTop3 {\n\tpadding-top: 18px !important;\n}\n\n.paddingTop4 {\n\tpadding-top: 24px !important;\n}\n\n.paddingTop5 {\n\tpadding-top: 30px !important;\n}\n\n.paddingTop6 {\n\tpadding-top: 36px !important;\n}\n\n.paddingTop7 {\n\tpadding-top: 42px !important;\n}\n\n.noPadding {\n\tpadding: 0px !important;\n}\n\n.spaceMarginBottom0 {\n\tmargin-bottom: 0;\n}\n\n.textBold {\n\tfont-weight: 500 !important;\n}\n\n.textBolder {\n\tfont-weight: 700 !important;\n}\n\n.textNormal {\n\tfont-weight: normal !important;\n}\n\n/*New Design Text Colors */\n\n.textDarkBlue {\n\tcolor: rgb(20, 39, 94) !important;\n}\n\n.textLightBlue {\n\tcolor: rgb(57, 87, 106) !important;\n}\n\n.textLightSandleGreen {\n\tcolor: rgb(76, 86, 41) !important;\n}\n\n.textLightBrown {\n\tcolor: rgb(115, 79, 33) !important;\n}\n\n.textMediumMaroon {\n\tcolor: rgb(87, 37, 51) !important;\n}\n\n.textBrown {\n\tcolor: rgb(160, 47, 24) !important;\n}\n\n.textMaroon {\n\tcolor: rgb(155, 49, 67) !important;\n}\n\n.textDarkBrown {\n\tcolor: rgb(83, 18, 16) !important;\n}\n\n.textMediumBrown {\n\tcolor: rgb(142, 28, 10) !important;\n}\n\n.textSkyBlue {\n\tcolor: rgb(37, 117, 141) !important;\n}\n\n.textGray {\n\tcolor: rgb(77, 65, 51) !important;\n}",".errorMessage {\n  margin-top: 5px;\n  margin-bottom: 5px;\n  display: block;\n  color: var(--alert-color);\n  font-size: 14px;\n  font-weight: normal;\n  /* margin-left: 5px; */\n}","@import '../helpers.css';\n@import '../utils.css';\n\n/** Admin - Common - Start **/\n.userText {\n\tpadding-top: 3px;\n\tcolor: var(--common-text-color);\n\tmargin: 0px;\n\tfont-size: 14px;\n}\n\n.panelHeader {\n\tborder-radius: 4px;\n\tpadding: 20px 25px;\n\tborder: 1px solid var(--primary-border);\n}\n\n.exportSection {\n\tbackground: var(--common-gray-bg-color);\n\tpadding: 24px 15px;\n\tdisplay: grid;\n\tgrid-template-columns: 28% 15% 55%;\n\talign-items: center;\n\tgrid-gap: 11px;\n\tborder: 1px solid var(--primary-border);\n\tborder-bottom: 0;\n\tborder-top-left-radius: 20px;\n\tborder-top-right-radius: 20px;\n}\n\n.exportSectionGridSub {\n\tgrid-template-columns: 50% 49% !important;\n}\n\n.exportText {\n\tcolor: var(--common-text-color) !important;\n\ttext-decoration: none !important;\n\tdisplay: inline-block;\n\tfloat: right;\n}\n\n.exportLinkImg {\n\tbackground: var(--primary-white-bg);\n\tpadding: 10px;\n\tmargin-left: 12px;\n\tborder-radius: 4px;\n}\n\n.exportImg {\n\twidth: 100%;\n\tmax-width: 16px;\n\tvertical-align: middle;\n}\n\n.linkBtn {\n\tline-height: 24px;\n\tdisplay: inline-block;\n\tvertical-align: middle;\n\tmargin-right: 15px;\n\ttext-align: center;\n}\n\n.table {\n\tdisplay: table;\n}\n\n.tableRow {\n\tdisplay: table-row;\n}\n\n.tableCell {\n\tdisplay: table-cell;\n\tfloat: none;\n}\n\n.formGroup {\n\tmargin-bottom: 6px;\n}\n\n.marginTop0 {\n\tmargin-top: 0;\n}\n\n.marginBottom20 {\n\tmargin-bottom: 20px;\n}\n\n\n/******************* Admin Banner Image Section Start ****************/\n.bannerImageBg {\n\twidth: 100%;\n\theight: 100%;\n\tmin-height: 179px;\n\tbackground-size: contain;\n\tbackground-repeat: no-repeat;\n\tbackground-position: 50% 50%;\n\tposition: relative;\n\tborder-radius: 0px;\n}\n\n.bannerDelete {\n\tposition: absolute;\n\ttop: 5px;\n\tright: 20px;\n}\n\n/*******************Admin Modal Start **********************/\na,\na:hover {\n\tcursor: pointer;\n}\n\n.exportLink {\n\tpadding-top: 10px;\n\tpadding-right: 10px;\n}\n\n.seachContent {\n\tpadding-left: 0px;\n\tmargin-bottom: 5px;\n}\n\n.marginBottom9 {\n\tmargin-bottom: 9px;\n}\n\n.spaceTop52 {\n\tmargin-top: 52px;\n}\n\n.profileViewInner {\n\tpadding: 10px;\n\tborder-top: 1px solid var(--primary-border);\n\tword-break: break-all;\n}\n\n.profileViewMain {\n\tborder: 1px solid var(--primary-border);\n\tborder-radius: 0px;\n\tborder-top: 0;\n}\n\n.profileViewlabel {\n\tdisplay: inline-block;\n\twidth: 38%;\n\tvertical-align: middle;\n}\n\n.profileViewMainContent {\n\tdisplay: inline-block;\n\twidth: 62%;\n\tvertical-align: middle;\n}\n\n.reviewsFormStar {\n\tfont-size: 32px;\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 2px;\n\tflex-wrap: wrap;\n}\n\n.reviewsFormStar svg {\n\tcursor: pointer;\n}\n\n.addLanguageText {\n\tfont-size: 16px;\n}\n\n/***************** Export Section Start *********************/\n@media screen and (max-width: 991px) {\n\t.exportSection {\n\t\tgrid-template-columns: 100%;\n\t}\n\n\t.spaceTop52 {\n\t\tmargin-top: 18px;\n\t}\n\n\t.exportText {\n\t\tfloat: none;\n\t\tmargin-top: 12px;\n\t}\n\n\t.exportSectionGridSub {\n\t\tgrid-template-columns: 100% !important;\n\t}\n}\n\n/***************** Export Section End *********************/\n/*******************Admin Modal Start **********************/\n\n/*******************Admin Modal End **********************/\n\n/*********************** Profile View Section  Start***********************/\n\n\n@media screen and (max-width: 767px) {\n\t.profileViewlabel {\n\t\twidth: 100%;\n\t\tmargin-bottom: 6px;\n\t\ttext-align: center;\n\t}\n\n\t.profileViewMainContent {\n\t\twidth: 100%;\n\t\ttext-align: center;\n\t}\n\n\t.panelHeader {\n\t\tpadding: 15px 15px;\n\t}\n\n}\n\n/*********************** Profile View Section  Start***********************/","@import '../admin-common.css';\n\n.addBlogCommonInputGrp {\n    margin-bottom: 24px;\n    padding-bottom: 24px;\n    border-bottom: 1px solid var(--primary-border);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"space1": `AddBlogDetails-space1-nhU2X`,
	"space2": `AddBlogDetails-space2-b3WAY`,
	"space3": `AddBlogDetails-space3-ixLwj`,
	"space4": `AddBlogDetails-space4-iC5Oz`,
	"space5": `AddBlogDetails-space5-rUbjT`,
	"space6": `AddBlogDetails-space6-QgDX_`,
	"space7": `AddBlogDetails-space7-wYTMJ`,
	"space8": `AddBlogDetails-space8-Qa9Bw`,
	"spaceTop1": `AddBlogDetails-spaceTop1-thvt5`,
	"spaceTop2": `AddBlogDetails-spaceTop2-zvXqU`,
	"spaceTop3": `AddBlogDetails-spaceTop3-yqq8V`,
	"spaceTop4": `AddBlogDetails-spaceTop4-J8AzO`,
	"spaceTop5": `AddBlogDetails-spaceTop5-hIcx3`,
	"spaceTop6": `AddBlogDetails-spaceTop6-YcXLr`,
	"spaceTop7": `AddBlogDetails-spaceTop7-WZzB7`,
	"spaceTop8": `AddBlogDetails-spaceTop8-W8C1U`,
	"noMargin": `AddBlogDetails-noMargin-LTWEv`,
	"padding1": `AddBlogDetails-padding1-aryVF`,
	"padding2": `AddBlogDetails-padding2-BhDLr`,
	"padding3": `AddBlogDetails-padding3-x162N`,
	"padding4": `AddBlogDetails-padding4-Ietab`,
	"padding5": `AddBlogDetails-padding5-dXPy2`,
	"padding6": `AddBlogDetails-padding6-PXG3n`,
	"padding7": `AddBlogDetails-padding7-oZ_AQ`,
	"paddingTop1": `AddBlogDetails-paddingTop1-GGqD0`,
	"paddingTop2": `AddBlogDetails-paddingTop2-wNAsj`,
	"paddingTop3": `AddBlogDetails-paddingTop3-e0Tdg`,
	"paddingTop4": `AddBlogDetails-paddingTop4-l8Ypj`,
	"paddingTop5": `AddBlogDetails-paddingTop5-zHc3b`,
	"paddingTop6": `AddBlogDetails-paddingTop6-rpaab`,
	"paddingTop7": `AddBlogDetails-paddingTop7-sVNVU`,
	"noPadding": `AddBlogDetails-noPadding-Kt0rQ`,
	"spaceMarginBottom0": `AddBlogDetails-spaceMarginBottom0-mjpBs`,
	"textBold": `AddBlogDetails-textBold-wdXr3`,
	"textBolder": `AddBlogDetails-textBolder-dzM5V`,
	"textNormal": `AddBlogDetails-textNormal-Ek6jR`,
	"textDarkBlue": `AddBlogDetails-textDarkBlue-rpbpO`,
	"textLightBlue": `AddBlogDetails-textLightBlue-gFNXs`,
	"textLightSandleGreen": `AddBlogDetails-textLightSandleGreen-Y3dFo`,
	"textLightBrown": `AddBlogDetails-textLightBrown-ufotR`,
	"textMediumMaroon": `AddBlogDetails-textMediumMaroon-yuvx5`,
	"textBrown": `AddBlogDetails-textBrown-uDoCa`,
	"textMaroon": `AddBlogDetails-textMaroon-WLLCd`,
	"textDarkBrown": `AddBlogDetails-textDarkBrown-jnTuc`,
	"textMediumBrown": `AddBlogDetails-textMediumBrown-JHN1Y`,
	"textSkyBlue": `AddBlogDetails-textSkyBlue-f6ZXy`,
	"textGray": `AddBlogDetails-textGray-joDYL`,
	"errorMessage": `AddBlogDetails-errorMessage-I3yRX`,
	"userText": `AddBlogDetails-userText-LjcwT`,
	"panelHeader": `AddBlogDetails-panelHeader-tW9L7`,
	"exportSection": `AddBlogDetails-exportSection-KTYlc`,
	"exportSectionGridSub": `AddBlogDetails-exportSectionGridSub-S5v8f`,
	"exportText": `AddBlogDetails-exportText-Wprf1`,
	"exportLinkImg": `AddBlogDetails-exportLinkImg-IM8gA`,
	"exportImg": `AddBlogDetails-exportImg-Aw4Xf`,
	"linkBtn": `AddBlogDetails-linkBtn-B__Ai`,
	"table": `AddBlogDetails-table-RD1ng`,
	"tableRow": `AddBlogDetails-tableRow-zKcow`,
	"tableCell": `AddBlogDetails-tableCell-jyvxv`,
	"formGroup": `AddBlogDetails-formGroup-li5nf`,
	"marginTop0": `AddBlogDetails-marginTop0-J57jK`,
	"marginBottom20": `AddBlogDetails-marginBottom20-BMIaJ`,
	"bannerImageBg": `AddBlogDetails-bannerImageBg-BrIap`,
	"bannerDelete": `AddBlogDetails-bannerDelete-NeQVR`,
	"exportLink": `AddBlogDetails-exportLink-Id88g`,
	"seachContent": `AddBlogDetails-seachContent-cgPNq`,
	"marginBottom9": `AddBlogDetails-marginBottom9-woYkn`,
	"spaceTop52": `AddBlogDetails-spaceTop52-FyWvT`,
	"profileViewInner": `AddBlogDetails-profileViewInner-ebEPV`,
	"profileViewMain": `AddBlogDetails-profileViewMain-dgcTf`,
	"profileViewlabel": `AddBlogDetails-profileViewlabel-Z5WQP`,
	"profileViewMainContent": `AddBlogDetails-profileViewMainContent-O6CvB`,
	"reviewsFormStar": `AddBlogDetails-reviewsFormStar-FTtYV`,
	"addLanguageText": `AddBlogDetails-addLanguageText-FqEpA`,
	"addBlogCommonInputGrp": `AddBlogDetails-addBlogCommonInputGrp-dBxnM`
};
module.exports = ___CSS_LOADER_EXPORT___;
